<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/Packet' }">分组管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/terminal' }">终端管理 ( {{$route.query.name}} )</el-breadcrumb-item>
						<el-breadcrumb-item v-if="$route.query.Packet" :to="{ path: '/iot/PacketData',query: {id: $route.query.Packet,name: $route.query.name}}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item v-else :to="{ path: '/iot/sensor',query: {id: $store.state.Iot.devicesdata1.id,name: $route.query.name }}">设备信息</el-breadcrumb-item>
						<el-breadcrumb-item>实时曲线</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="main">
					<div :class="$store.state.width<$store.state.minwidth?'quxianM':'quxianP'" id="myChart"></div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				myload: true,
				data: [],
				Content: {
					maxContent: null,
					minContent: null
				}
			}
		},
		mounted() {
			this.load();
		},
		methods: {
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('myChart'));
				var unit = this.$store.state.Iot.device.unit != 0 ? "(" + this.$store.state.Iot.device.unit + ")" : "";
				// 绘制图表
				myChart.setOption({
					title: {
						text: this.$store.state.Iot.device.description
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params, ticket) {
							var result = params[0].value[0] + " <br/>" + params[0].seriesName + " : " + params[0].value[1];
							return result;
						}
					},
					xAxis: {
						type: 'time'
					},
					legend: {
						data: [this.$store.state.Iot.device.alias + unit],
						x: "right"
					},
					grid: {
						left: '2%',
						right: '60px',
						containLabel: true
					},
					yAxis: {
						max: this.Content.maxContent,
						min: this.Content.minContent,
						type: 'value'
					},
					series: [{
						name: this.$store.state.Iot.device.alias + unit,
						smooth: true,
						type: 'line',
						itemStyle: {
							normal: {
								color: 'rgb(140, 183, 240)'
							}
						},
						data: this.data
					}],
					dataZoom: [{
							type: 'slider',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'slider',
							yAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							xAxisIndex: 0,
							filterMode: 'none'
						},
						{
							type: 'inside',
							yAxisIndex: 0,
							filterMode: 'none'
						}
					]
				});
			},
			load() {
				this.$store.commit('mainload', true);
				let value = {
					devices_id: this.$route.query.id,
					start_time: ((new Date().getTime() - 24 * 60 * 60 * 1000) / 1000).toFixed(0),
					end_time: (new Date().getTime() / 1000).toFixed(0),
					order: "updatetime asc"
				};
				this.getdevicesdata1(value)
					.then((response) => {
						if (response.data.code == 1) {
							this.Content.minContent = Number(response.data.data.minContent);
							this.Content.maxContent = Number(response.data.data.maxContent);
							for (var i = 0; i < this.$store.state.Iot.devicesdata1.list.length; i++) {
								this.data.push([
									this.Totime(this.$store.state.Iot.devicesdata1.list[i].createtime),
									this.$store.state.Iot.devicesdata1.list[i].content
								])
							}
							this.getsonser();
							this.$store.commit('mainload', false);
						}
					});
			},
			getsonser() {
				let value = {
					id: this.$route.query.id
				};
				this.getdevice(value)
					.then((response) => {
						if (response.data.code == 1) {
							this.drawLine();
						}
					});
			}
		}
	}
</script>
<style scoped>
	.quxianP {
		float: center;
		width: 100%;
		height: 750px;
		margin-top: 10px;
	}

	.quxianM {
		float: center;
		width: 100%;
		height: 400px;
		margin-top: 10px;
	}

	.main {
		background-color: white;
		padding: 5px;
		margin-top: 10px;
	}

	.bread {
		height: 14px;
		padding: 8px 0;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bread {
			padding-left: 5px;
		}
	}
</style>
